import { createReducer, on } from '@ngrx/store';
import { EncountersActions } from '@mona/pdms/data-access-encounters';
import { AuditEvent } from '../../../../../shared/src/lib/types/r4b.type';
import * as AuditLogActions from '../actions/audit.log.actions';

/**
 * Audit Log State
 */
export interface AuditLogState {
    auditLogs: AuditEvent[];
    loading: boolean;
    error: any | null;
}

/**
 * initial Audit Log State
 */
export const initialState: AuditLogState = {
    auditLogs: [],
    loading: false,
    error: null,
};

/**
 * Audit Log reducer
 */
export const auditLogReducer = createReducer(
    initialState,
    on(AuditLogActions.loadAuditLogs, state => ({
        ...state,
        loading: true,
        error: null,
    })),
    on(AuditLogActions.loadAuditLogsSuccess, (state, { auditLogs }) => ({
        ...state,
        auditLogs,
        loading: false,
    })),
    on(AuditLogActions.loadAuditLogsFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error: error.message || 'An unknown error occurred',
    })),
    on(AuditLogActions.clearAuditLog, () => initialState),
);
